import { render } from "./perpageSort.vue?vue&type=template&id=5e83ce3d"
import script from "./perpageSort.vue?vue&type=script&lang=js"
export * from "./perpageSort.vue?vue&type=script&lang=js"

import "./perpageSort.vue?vue&type=style&index=0&id=5e83ce3d&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__